module.exports = "/packs/icon-calendar-e30b596dc2319e20bc53d3a411f453e9.png";